<template>
    <div style="height: 100%">
        <div class="container">
            <div class="login">
                <h5>欢迎访问</h5>
                <el-form :model="form" :rules="rules" ref="form" @submit.native.prevent>
                    <el-form-item prop="username">
                        <el-input placeholder="请输入用户名" v-model="form.username" autofocus="true" clearable></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input placeholder="请输入密码" v-model="form.password" show-password></el-input>
                    </el-form-item>
                    <el-form-item prop="iCode">
                        <el-input placeholder="请输入验证码" v-model="form.iCode" style="width: 150px;float: left"></el-input>
                        <img :src="codeImage" alt="" style="float: right;margin-top: 5px;cursor: pointer" @click="changeImageCode">
                    </el-form-item>
                    <el-form-item>
                        <el-button type="default" class="button" native-type="submit" @click="login('form')">登录</el-button>
                    </el-form-item>
                  <el-form-item>
                    <el-divider>OR</el-divider>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" class="button"  @click="ssoLogin">Login with Disney MyID</el-button>
                  </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="beian">
            <a href="http://www.beian.miit.gov.cn" target="_blank">沪ICP备20000373号-1</a>
        </div>
    </div>
</template>
<script>
import qs from 'qs';
import JSEncrypt from 'jsencrypt';

export default {
  name: "Login",
  data() {
    return {
      codeImage: "",
      form: {
        username: '',
        password: '',
        iCode: '',
        iCodeKey: ""
      },
      rules: {
        username: [
          {required: true, message: "请输入用户名"}
        ],
        password: [
          {required: true, message: "请输入密码"}
        ],
        iCode: [
          {required: true, message: "请输入验证码"}
        ],
      }
    }
  },
  beforeMount() {
    this.changeImageCode();
  },
  methods: {
    changeImageCode() {
      const axios = require('axios');
      axios.create().get("/imgcode").then(response => {
        this.codeImage = "data:image/jpeg;base64," + response.data;
        this.form.iCodeKey = response.headers['i-code-key'];
      })
    },
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }

        const data = JSON.parse(JSON.stringify(this.form));
        data.password = this.encrypt(data.password);

        this.$axios.post("/login", qs.stringify(data), {
          headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
        }).then((result) => {
          if (result.success) {
            const data = result.data;

            if (data.tips) {
              if (data.force) {
                this.$alert(data.tips, '提示', {
                  confirmButtonText: '去修改',
                  callback: () => {
                    this.onLoginSuccess(data, "/modifypass");
                  }
                });
              } else {
                this.$confirm(data.tips, '提示', {
                  confirmButtonText: '去修改',
                  cancelButtonText: '下次再说',
                  type: 'info'
                }).then(() => {
                  this.onLoginSuccess(data, "/modifypass");
                }).catch(() => {
                  this.onLoginSuccess(data, "");
                });
              }
            } else {
              this.onLoginSuccess(data, "");
            }
          } else {
            this.$message.error({
              message: result.message,
              duration: 6000
            });
            this.changeImageCode();
          }
        });
      });
    },
    onLoginSuccess(data, path) {
      sessionStorage.setItem("auth-token", data.token);
      sessionStorage.setItem("context", JSON.stringify(data));
      Object.assign(this.$root.$data, data);

      this.$root.refreshCustomer().then(() => {
        this.$root.refreshBusiness().then(() => {
          const redirect = path || this.$route.query.redirect;
          this.$router.push(redirect ? redirect : "/");
        });
      });
    },
    encrypt(text) {
      const publicKty = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjDMAZ8dLWV8zxzvDBDeJRYVGqyfhhauAZfl3eF6xnRcJjMadDW8CNPKqYSl5sLtqV8vbQdO1gJLYDOAwjEahkZnf1ftHjM7tFyQlWrUMqyPEmNRtPiJd//7ybitGdJ/VkaHI65qA/DkN5q+u523G3jK+1CdGp5UCcImqIZAwIx2pR8ZN7NyXoAcau+XbG2tFAp5A4FBhEjcJn6nDUzJiqqF6p1VpD9csi/45L5v6ruxy/oao5LrC22GImvI7rMRawXRy3u/k1VQZEN7dzl91wbZzBIdBjebfdTFWOdHpiPbBSYu9xihoT9csG0ZNA3LKR203xFkWEoz+pQq89KHpBwIDAQAB";
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKty);
      return encrypt.encrypt(text);
    },
    ssoLogin() {
      location.href = "https://idp.myid.disney.com/idp/startSSO.ping?PartnerSpId=Future SMS";
    }
  }
}
</script>
<style scoped>
    .container {
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;
    }

    .login {
        width: 300px;
        margin: 0 auto;
        text-align: center;
    }

    .button {
        width: 100%;
    }

    .locale {
        position: absolute;
        top: 20px;
        right: 20px;
    }

    .beian {
        position: absolute;
        bottom: 0;
        line-height: 30px;
        width: 100%;
        text-align: center;
        font-size: 13px;
    }

    .beian a {
        text-decoration: underline;
        color: black;
    }

    .el-divider--horizontal {
      margin: 5px 0;
    }

    .el-divider__text {
      background-color: #f3f3f4;
    }
</style>